"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _auth = require("aws-amplify/auth");
var _googleOauth = _interopRequireDefault(require("./googleOauth"));
var _microsoftOauth = _interopRequireDefault(require("./microsoftOauth"));
var _setCredentials = _interopRequireDefault(require("./setCredentials"));
var _clearCredentials = _interopRequireDefault(require("./clearCredentials"));
var _getCookie = _interopRequireDefault(require("./getCookie"));
var _constants = _interopRequireDefault(require("./constants"));
var _renewCredentials = function renewCredentials() {
  var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var signInModeCookieResponse = (0, _getCookie["default"])('signInMode');
  if (!signInModeCookieResponse.cookieExists) {
    _clearCredentials["default"].all();
    return Promise.reject(new Error('Not logged in.'));
  }
  switch (signInModeCookieResponse.cookieValue) {
    case _constants["default"].cognito:
      return (0, _auth.fetchAuthSession)().then(function (data) {
        var _data$tokens, _data$tokens2;
        _setCredentials["default"].cognito((_data$tokens = data.tokens) === null || _data$tokens === void 0 || (_data$tokens = _data$tokens.idToken) === null || _data$tokens === void 0 ? void 0 : _data$tokens.toString());
        return {
          idToken: (_data$tokens2 = data.tokens) === null || _data$tokens2 === void 0 || (_data$tokens2 = _data$tokens2.idToken) === null || _data$tokens2 === void 0 ? void 0 : _data$tokens2.toString()
        };
      })["catch"](function (err) {
        _clearCredentials["default"].all();
        Promise.reject(err);
      });
    case _constants["default"].microsoft:
      var microsoftRefreshTokenCookieResponse = (0, _getCookie["default"])('microsoftRefreshToken');
      if (!microsoftRefreshTokenCookieResponse.cookieExists) {
        _clearCredentials["default"].all();
        return Promise.reject(new Error('Not logged in.'));
      }
      if (retry) return _microsoftOauth["default"].refreshMicrosoftAuthToken().then(function () {
        var microsoftIdTokenCookieResponse = (0, _getCookie["default"])('microsoftIdToken');
        if (microsoftIdTokenCookieResponse.cookieExists) {
          return {
            idToken: microsoftIdTokenCookieResponse.cookieValue
          };
        }
        _clearCredentials["default"].all();
        return Promise.reject(new Error('Session revalidation failure.'));
      })["catch"](function () {
        _renewCredentials(false);
      });
      _clearCredentials["default"].all();
      return Promise.reject(new Error('Session revalidation failure.'));
    case _constants["default"].google:
      var googleRefreshTokenCookieResponse = (0, _getCookie["default"])('googleRefreshToken');
      if (!googleRefreshTokenCookieResponse.cookieExists) {
        _clearCredentials["default"].all();
        return Promise.reject(new Error('Not logged in.'));
      }
      if (retry) return _googleOauth["default"].refreshGoogleAuthToken().then(function () {
        var googleIdTokenCookieResponse = (0, _getCookie["default"])('googleIdToken');
        if (googleIdTokenCookieResponse.cookieExists) {
          return {
            idToken: googleIdTokenCookieResponse.cookieValue
          };
        }
        _clearCredentials["default"].all();
        return Promise.reject(new Error('Session revalidation failure.'));
      })["catch"](function () {
        _renewCredentials(false);
      });
      _clearCredentials["default"].all();
      return Promise.reject(new Error('Session revalidation failure.'));
    default:
      _clearCredentials["default"].all();
      return Promise.reject(new Error('Not logged in.'));
  }
};
var _default = exports["default"] = _renewCredentials;